import Vue from "vue";
import apis from "@/config/api.config.js"
import qs from "qs";
import {
  DropdownMenu,
  DropdownItem,
  Dialog
} from 'vant';
import {
  Cell,
  CellGroup
} from 'vant';
import {
  Icon
} from 'vant';
import {
  Search
} from 'vant';
import {
  Toast
} from 'vant';
import {
  Button
} from 'vant';
import { Field } from 'vant';

Vue.use(Field);
Vue.use(Button);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

export default {
  name: "index",
  data() {

    return {
      username: '',
      value: 0,
      value1: -1,
      value2: '',
      switch1: false,
      switch2: false,
      option: [{
          text: '请选择',
          value: 0
        },
        {
          text: '普通群众',
          value: 1
        },
        {
          text: '党员身份',
          value: 2
        },
      ],
      option1_title: '请选择',
      option1: [{
          text: '党支部0',
          value: 0,
          show: 1
        },
        {
          text: '党支部1',
          value: 1,
          show: 1
        },
      ],
      hasIdentify: false,
      valueable: true,
      baseUrl: 'https://activity.sznews.com/front/luohu_question_front/index.php?s=',
      curQues: 0,
      btnText: '下一题',
      isChosen: [],
      quesList: [],
      quesReady: false,
      hasFinishQues: false,
      _playAgain: 0,
      usernameShow: false,
    };
  },

  methods: {
    usernameClose() {
      if(!this.username) {
        this.usernameShow = true
      }
    },
    usernameConfirm() {
      if(this.username) {
        console.log('补充信息');
        this.addNameInfo();
      }
    },
    usernameCancel() {
      this.$router.replace('/')
    },
    addNameInfo() {
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      })
      const that = this;
      $.post({
        url: that.baseUrl + 'index/user/addNameInfo',
        data: {
          token: localStorage.getItem('lgquestions'),
          activity_id: that.id,
          type: 1,
          name: that.username
        },
        success(res) {
          Toast.clear()
          if(res.code == 200) {
            that.usernameShow = 0;
            Toast(res.msg)
          }
          
        }
      })
    },
    onConfirm(index) {
      this.value1 = index;
      this.option1_title = this.option1[index].text;
      this.$refs.item.toggle();
    },
    onSearch(val) {
      Toast(val);
    },
    onCancel() {
      // Toast('取消');
      this.$refs.item.toggle();
    },
    onInput(val) {
      // console.log(val);
      for (let i = 0; i < this.option1.length; i++) {
        if (this.option1[i].text.indexOf(val) == -1) {
          this.option1[i].show = 0;
        } else {
          this.option1[i].show = 1;
        }
      }
    },

    onChosen() {
      if (!this.value) {
        Toast('请选择身份');
      } else if (this.value) {
        if(!this.username) {
          Toast('请填写姓名')
        }else {
          if (this.value == 1) {
            this.hasIdentify = true;
            this.addInfo()
          } else {

            if (this.value1 >= 0) {
              Dialog.confirm({
                  message: '所属党支部一经确认无法更改 是否确认',
                })
                .then(() => {
                  // on confirm
                  this.hasIdentify = true;
                  this.addInfo()
                })
                .catch(() => {
                  // on cancel
                });
  
            } else {
              Toast('请选择所属党支部')
            }
  
          }
        }


      }


    },

    toNextQues() {
      const that = this;
      let count = 0;
      let options = that.quesList[that.curQues].options;

      for (let i = 0; i < options.length; i++) { // 判空 只要有一项选中 count就不为0
        count += options[i].chosen
      }

      if (!count) {
        Toast('请至少选择一项');
        return false
      }

      let type = that.type;
      var answer = '';

      for (let i = 0; i < options.length; i++) {
        if (options[i].chosen) {
          answer += (options[i].key + ',')
        }
      }
      answer = answer.substring(0, answer.length - 1);
      console.log(answer);

      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中',
      });
      $.post({
        url: that.baseUrl + 'index/questions/mark',
        data: {
          activity_id: that.id,
          token: localStorage.getItem('lgquestions'),
          value: answer,
          type,
          id: that.quesList[that.curQues].id

        },
        success(res) {
          Toast.clear();
          Toast({
            message: res.msg,
            forbidClick: true,
            duration: 2000,
            onClose: function () {
              that.curQues++;
              if (that.curQues == that.quesList.length - 1) {
                that.btnText = '提 交';

              }

              if (that.curQues == that.quesList.length) {
                Toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  message: '提交中',
                });
                $.post({
                  url: that.baseUrl + 'index/questions/getmark',
                  data: {
                    activity_id: that.id,
                    token: localStorage.getItem('lgquestions'),
                    type: that.type
                  },
                  success(res) {
                    Toast.clear();
                    console.log(res);
                    that.score = res.data;
                    that.hasFinishQues = true;
                    that.quesRes = res.status;
                  }
                })
              }
            }
          })

        }
      })


    },
    onChoose(index) {
      const that = this;

      let type = that.quesList[that.curQues].question_type;
      let options = that.quesList[that.curQues].options;
      if (options[index].chosen) { // 若已选中 取消选中
        options[index].chosen = 0
      } else { // 若未选中 
        if (type == '多选题') {
          options[index].chosen = 1

        } else {

          for (let i = 0; i < options.length; i++) {
            options[i].chosen = 0
          }
          options[index].chosen = 1

        }
      }


    },

    getUserNameExisted() {
      const that = this;
      $.post({
        url: that.baseUrl + 'index/user/getUserNameExisted',
        data: {
          token: localStorage.getItem('lgquestions'),
          activity_id: that.id,
        },
        success(res) {
          console.log('getUserNameExisted',res);
          if(res.status == 'error') {
            that.usernameShow = true
          }
        }
      })
    },

    getQuestions() {
      const that = this;
      let toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中',
      });
      console.log(that._playAgain);

      if(!that._playAgain) {
        that.getUserNameExisted()
      }



      $.post({
        url: that.baseUrl + 'index/questions/list',
        data: {
          token: localStorage.getItem('lgquestions'),
          activity_id: that.id,
          again: that._playAgain
        },
        success(res) {
          if (res.status == 200) {

            for (let i = 0; i < res.data.length; i++) {
              var options = [];
              var obj = res.data[i];
              for (let key in obj) {
                if (key.indexOf('option') > -1) {
                  options.push({
                    key: key.replace('option', ''),
                    value: obj[key] ? obj[key].split('.')[1] : null,
                    chosen: 0
                  })
                }
              };
              obj['options'] = options;
              res.data[i] = obj;
            }
            console.log('res.data', res.data);
            that.quesList = res.data;
            Toast.clear()
          }
        },

      })
    },

    onChange(e) {
      // console.log(e);
      if (this.value == 2) {
        this.valueable = false
      } else {
        this.valueable = true
      }
    },

    // checkUserId() {
      
    //   const that = this;
    //   let toast = Toast.loading({
    //     duration: 0, // 持续展示 toast
    //     forbidClick: true,
    //     message: '提交中',
    //   });
    //   console.time('获取用户身份：checkUserId')
    //   $.post({
    //     url: that.baseUrl + 'index/user/getUserExisted',
    //     data: {
    //       activity_id: that.id,
    //       token: localStorage.getItem('lgquestions')
    //     },
    //     success(res) {
    //       console.log(res);
    //       Toast.clear()
          
    //       if (res.status == "success") {
    //         that.hasIdentify = false;
    //         console.timeEnd('获取用户身份：checkUserId')
    //       } else if (res.status == "error") {
    //         that.hasIdentify = true;
    //         that.getQuestions()
    //       } else {
    //         // this.hasIdentify = true;
    //         VerifyState()
    //       }
    //     }
    //   })
      
    // },
    getIdList() {
        const that = this;
        let toast = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '加载中...',
        });
        let post_data = {
            token: localStorage.getItem('luoohutoken'),
        };
        that
            .axios({
                method: "post",
                // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                // url: apis.getActivityList,
                url: apis.getInfomation,
                data: qs.stringify(post_data),
            })
            .then((res) => {
                console.log(res);
                res = res.data;
                if (res.code == 200) {
                    Toast.clear()
                    that.userName = res.data.name;

                    that.userIndex = res.data.rownum;//获取到的值显示
                    // console.log(that.userInfo);


                }
                else {
                    that.userName = "张三";

                    that.userIndex = 9999;//显示第几名
                }
            })
            .catch((rej) => {
                console.log(rej);
            });
    },
    getDepartmentList() {
        const that = this;
        let toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '提交中',
        });
        let post_data = {
          activity_id: that.id
        };
        that
          .axios({
            method: "post",
            // headers: { "Content-Type": "application/x-www-form-urlencoded" },
            // url: apis.getActivityList,
            url: apis.getDepartmentList,
            data: qs.stringify(post_data),
          })
          .then((res) => {
            // console.log(res);
  
            Toast.clear();// 清除所有弹框
            res = res.data;
            if (res.status == 200) {
              // console.log(res.msg);
              that.option1 = [];
            for (let i = 0; i < res.msg.length; i++) {
              const element = res.data[i];
              that.option1.push({
                text: res.msg[i]['name'],
                value: i,
                show: 1,
                id: res.msg[i]['id'],
              })

            }
            console.log(that.option1);
  
              // let columns = [];
              let school = [];
              for (let i = 0; i < res.msg.length; i++) {
                school.push(
                  {
                    text: res.msg[i]['name'],
                    id: res.msg[i]['id'],
                    grade: []
                  }
                )
                for (let j = 0; j < res.msg[i]['grades'].length; j++) {
                  let grades = res.msg[i]['grades'][j]
                  let itemson = {
                    text: grades['name'],
                    id: grades['id'],
                    children: []
                  }
                  school[i].grade.push(itemson)
                  // console.log(item);
                  for (let k = 0; k < grades['class_count']; k++) {
                    // console.log(school,grades,k+1);
                    let itemgrandson = {
                      text: k + 1
                    }
                    itemson.children.push(itemgrandson)
                    // console.log(itemgrandson);
  
                  }
                }
  
              }
  
              console.log(school);
              that.school = school;
  
            }
          })
          .catch((rej) => {
            console.log(rej);
          });
      },

    getIdLists() {
      const that = this;
      console.log(that.id);
      $.post({
        url: that.baseUrl + `index/department/list`,
        data: {
          activity_id: that.id
        },
        success(res) {
          console.log(res);
          if (res.status == 200) {
            that.option1 = [];
            for (let i = 0; i < res.data.length; i++) {
              const element = res.data[i];
              that.option1.push({
                text: element.name,
                value: i,
                show: 1,
                id: element.id
              })

            }
            console.log(that.option1);

          }
        },
      });
    },
    addInfo() {
      const that = this;
      $.post({
        url: that.baseUrl + 'index/user/addinfo',
        data: {
          activity_id: that.id,
          token: localStorage.getItem('lgquestions'),
          department_id: that.value == 1 ? 0 : that.option1[that.value1].id,
          type: 1,
          name: that.username
        },
        success(res) {
          console.log(res);
          that.getQuestions()

        }
      })
    },

    playAgain(again) {

      this.hasFinishQues = false;

      this.curQues = 0;
      this.btnText = '下一题';
      this._playAgain = again;
      console.log(this._playAgain);
      this.getQuestions();
    },

    toRank() {
      this.$router.replace({
        name: 'rank',
        query: {
          id: this.id,
          type: 0
        }
      })
    },

    confirmRes() {
      this.$router.replace('/list')
    }


  },
  created() {
    const that = this;
    that.id = that.$route.query.id;
    that.type = that.$route.query.type;
  },
  mounted() {
    const that = this;
    if (that.type == 0) {
      that.hasIdentify = true;
    //   that.getQuestions()
    } else {
    //   that.checkUserId();

      that.getDepartmentList();
    }

  },
};